export default __webpack_public_path__ + "static/media/screen1.b9536c20.png";